import { formatDay, formatMoney, formatPercent, moneySign } from "@/shared/lib";

import type { DailyResultItem } from "../model/types";

/**
 * Строка истории по дням. Figma: паттерн таблицы `Trade Data` (25:125).
 *
 * `percent` приходит с тремя знаками после запятой, `amount` — с двумя;
 * точность источника сохраняется как есть, `formatPercent` её не приводит.
 */
export function DailyResultRow({ item }: { item: DailyResultItem }) {
  const sign = moneySign(item.amount);
  const tone = sign < 0 ? "text-status-loss" : sign > 0 ? "text-status-profit" : "text-text-secondary";

  return (
    <div className="flex items-center justify-between border-b border-border-subtle px-1 py-3 last:border-b-0">
      <span className="text-label font-medium text-text-secondary">{formatDay(item.date)}</span>
      <div className="flex items-center gap-3">
        <span className={`w-[68px] text-right text-label font-semibold ${tone}`}>
          {formatPercent(item.percent, { sign: "always" })}
        </span>
        <span className={`w-[96px] text-right text-label font-semibold ${tone}`}>
          {formatMoney(item.amount, { sign: "always" })}
        </span>
      </div>
    </div>
  );
}
